import React from 'react';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import BackgroundOperation from 'images/solutionPage/backgrounds/backgroundOperation.svg';
import { breakpoint } from 'utils/mediaQueries';
import BackgroundOperationMobile from 'images/solutionPage/backgrounds/backgroundOperationMobile.svg';

const OperationBackground = styled(Grid)`
  z-index: -1;
  height: 100%;
  width: 100%;
  position: absolute;
  top:0;
  padding-bottom: 4rem;
  background-position: top;
  margin-top: -15rem;
  background-image: url("${BackgroundOperation}");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  ${breakpoint.down('md')` margin-top: 0;
  background: url("${BackgroundOperationMobile}") no-repeat;
  background-size: 100% 36%;`}
  ${breakpoint.down('sm')`
    background: url("${BackgroundOperationMobile}") no-repeat;
    background-size: 100% 36%;`};
  ${breakpoint.only('xxs')`    
  background: url("${BackgroundOperationMobile}
") no-repeat;
    background-size: 100% 36%;margin-top:2rem`};
`;
const OperationBlockBackground = () => {
  return <OperationBackground />;
};
export default OperationBlockBackground;
